import { Component } from "react";
import Box from '@mui/material/Box';
import RecoverPasswordForm from "./form/RecoverPasswordForm";
import FormHeader from "../../../../components/FormHeader";
import { useParams } from "react-router-dom";
import { getUserData } from "../../../../api/accountApi";

type Props = {
  title: string,
  submitButtonRedirect: string,
  labelNewPasswordText: string,
  params?: { passwordKey: string }
};

type State = {
  email: string
}

function withParams(Component: any) {
  return (props: Props) => <Component {...props} params={useParams()} />;
}

class RecoverPasswordThird extends Component<Props, State> {

  setEmail(email: string) {
    this.setState({
      email
    });
  }

  componentDidMount() {
    document.body.classList.add("grey-background");
    this.setEmail('');
    getUserData(this.props.params?.passwordKey || '')
    .then((response) => {
      this.setEmail(response.data.email);
    })
  }

  componentWillUnmount() {
    window.location.reload();
    document.body.classList.remove("grey-background");
  }
  
  render() {
    return (
      <Box>
        <FormHeader title={this.props.title}></FormHeader>
        <RecoverPasswordForm email={this.state ? this.state.email : ''} passwordKey={this.props.params?.passwordKey || ''} submitButtonRedirect={this.props.submitButtonRedirect} submitButtonText='Enviar' cancelButtonRedirect="/web/login" labelNewPasswordText={this.props.labelNewPasswordText} isChangePassword={false}></RecoverPasswordForm>
      </Box>
    );
  }
}

export default withParams(RecoverPasswordThird);